import { Injectable, signal } from '@angular/core';
import { decodeToken, type DecodedToken } from '@shared/utils/jwt';

export type Theme = 'light' | 'dark';

export interface CurrentUser {
  email?: string;
  firstName?: string;
  lastName?: string;
}

@Injectable({ providedIn: 'root' })
export class GlobalStore {
  private readonly _theme = signal<Theme>('light');
  private readonly _currentUser = signal<CurrentUser | null>(null);

  readonly theme = this._theme.asReadonly();
  readonly currentUser = this._currentUser.asReadonly();

  setTheme(theme: Theme): void {
    this._theme.set(theme);
  }

  toggleTheme(): void {
    this._theme.update((t) => (t === 'light' ? 'dark' : 'light'));
  }

  setCurrentUserFromToken(token: string | null): void {
    if (!token) {
      this._currentUser.set(null);
      return;
    }
    const decoded = decodeToken(token);
    if (!decoded) {
      this._currentUser.set(null);
      return;
    }
    this._currentUser.set(toCurrentUser(decoded));
  }
}

function toCurrentUser(decoded: DecodedToken): CurrentUser {
  return {
    email: typeof decoded.email === 'string' ? decoded.email : undefined,
    firstName: typeof decoded.first_name === 'string' ? decoded.first_name : undefined,
    lastName: typeof decoded.last_name === 'string' ? decoded.last_name : undefined,
  };
}
